import TemplateNames from './TemplateNames';

export default {
  title: 'Messages envoyés',
  columns: {
    recipient: 'Destinataire',
    template: 'Modèle',
    status: 'Statut',
    opened: 'Ouvert',
    clicked: 'Cliqué',
    sent_at: 'Envoyé le',
  },
  labels: {
    empty_list: 'Aucun message envoyé',
    load_failed: 'Impossible de charger vos messages envoyés. Veuillez recharger la page ou contacter le support.',
    yes: 'Oui',
    no: 'Non',
    clicked_at: 'Cliqué le : {{date}}',
    opened_at: 'Ouvert le : {{date}}',
  },
  message_statuses: {
    sent: 'Envoyé',
    delivered: 'Délivré',
    failed: 'Échoué',
  },
  template_names: TemplateNames,
  toasts: {
    failed_to_load_data: 'Impossible de charger les données',
  },
};
